import baseUrl from "./baseUrl";

const getImageUrl = (imageName) => {
	//get api url form env
	let api = baseUrl;

	if (api[api.length - 1] !== "/") {
		const url = `${api}/files/${imageName}`;
		return url;
	}

	const url = `${api}files/${imageName}`;
	return url;
};

export default getImageUrl;
